import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/site-workspace/:siteId");

export const Route = createFileRoute("/site-workspace/$siteId")({
  head: () => ({
    meta: [
      { title: "Site workspace detail — LevelLoad" },
      { name: "description", content: "One site's workspace in LevelLoad transport planning." },
      { property: "og:title", content: "Site workspace detail — LevelLoad" },
      {
        property: "og:description",
        content: "One site's workspace in LevelLoad transport planning.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
